import axios from 'axios'
import { add, sub } from 'date-fns'
import type {
  ClientAddress,
  ClientContact,
  ClientDashboardData,
  ClientType,
  ClientTypePost,
  SinceUntilValidityCheck,
} from '@/types/clientType'

export default class {
  static async postClient(client: Omit<ClientTypePost, 'id'>) {
    return axios.post<ClientType>(`clients`, client)
  }

  static async getClientById(id: string) {
    return axios.get<ClientType>(`clients/${id}`)
  }

  static async putClient(client: ClientType) {
    return axios.put<ClientType>(`clients/${client.id}`, client)
  }

  static async getClientAddressById(clientId: string, addressId: string) {
    return axios.get<ClientAddress>(
      `clients/${clientId}/client_addresses/${addressId}`,
    )
  }

  static async postClientAddress(
    clientId: string,
    address: Omit<ClientAddress, 'id'>,
  ) {
    return axios.post<ClientAddress>(
      `clients/${clientId}/client_addresses`,
      address,
    )
  }

  static async putClientAddress(clientId: string, address: ClientAddress) {
    return axios.put<ClientAddress>(
      `clients/${clientId}/client_addresses/${address.id}`,
      address,
    )
  }

  static async deleteClientAddress(clientId: string, addressId: string) {
    return axios.delete<{ status: number }>(
      `clients/${clientId}/client_addresses/${addressId}`,
    )
  }

  static async postClientContact(
    clientId: string,
    contact: Omit<ClientContact, 'id'>,
  ) {
    return axios.post<ClientContact>(
      `clients/${clientId}/client_contacts`,
      contact,
    )
  }

  static async putClientContact(clientId: string, contact: ClientContact) {
    return axios.put<ClientContact>(
      `clients/${clientId}/client_contacts/${contact.id}`,
      contact,
    )
  }

  static async deleteClientContact(clientId: string, contactId: string) {
    return axios.delete(`clients/${clientId}/client_contacts/${contactId}`)
  }

  static async getClientDashboardDataById(id: string) {
    return axios.get<ClientDashboardData>(`clients/${id}/dashboard`, {
      params: {
        since: sub(new Date(), { months: 22 }),
        until: add(new Date(), { months: 3 }),
      },
    })
  }

  static async clientLookupByBsn(bsn: Record<'bsn', string>) {
    return axios.post(`clients/lookup_by_bsn`, bsn)
  }

  static async sinceUntilValidityCheck(check: SinceUntilValidityCheck) {
    return axios.get<{ valid: boolean }>(`clients/${check.id}/check`, {
      params: {
        since: check.since,
        ...(check.until && { until: check.until }),
      },
    })
  }
}
